export let __DEBUG__ = process.env.REACT_APP_ENV === "development";
export let __STAGING__ = process.env.REACT_APP_ENV === "staging";
export let __PROD__ = !__STAGING__ && process.env.REACT_APP_ENV === "production";
